import createSvgIcon from '../Utils/CreateSvgIcon';

export const Share = createSvgIcon(
  <path d="M18.9995 14.4586L18.9995 14.0005L18.9995 12.0005H20.9995L20.9995 14.0005V19.0005L20.9995 21.0005H18.9995H4.99951H2.99951V19.0005V14.0005V12.0005H4.99951V14.0005V14.4586V19.0005H18.9995L18.9995 14.4586ZM8.41417 9.36344L10.9487 6.82889L10.9487 15.1959H12.9487L12.9487 6.82693L15.4852 9.36344L16.8995 7.94923L12.6568 3.70659L11.9497 2.99948L11.2426 3.70659L6.99996 7.94923L8.41417 9.36344Z" />,
  'Share',
);
